import React, { useState, useEffect } from 'react';
import './UpdateProjectDetails.css';
import DatePicker from 'react-datepicker';
import { format, parseISO, parse, isValid, addMonths } from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import { showToast } from '../toastUtils';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import FullscreenLoader from '../FullscreenLoader';
import { queuedApiFetch, apiFetch } from '../api';

function UpdateProjectDetails() {
  const navigate = useNavigate();
  const [currentProject, setCurrentProject] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const getProjectDetails = localStorage.getItem('projectDetails');
  const selectedProjectDetail = JSON.parse(getProjectDetails);
  const projectNum = selectedProjectDetail.projectNumber;
  const accountId = localStorage.getItem('accountId');
  const [ContractVendors, setContractVendors] = useState([]);
  const [ConsultantVendors, setConsultantVendors] = useState([]);

  //new code updations
  const getUserDetails = localStorage.getItem('userDetails');
  const userDetails = getUserDetails ? JSON.parse(getUserDetails) : '';
  const userId = userDetails ? userDetails.id : '';
  const getUserAccess = userDetails ? userDetails.access_level : '';
  const [userCompany, setUserCompany] = useState(0);
  const getUserCompanyDetails = userCompany;
  const getUserEmail = localStorage.getItem('userEmail');
  const [userPermission, setUserPermission] = useState(0);
  const [userRoleManual, setUserRolesManual] = useState([]);
  const [proj_access_level, setProjAccessLevel] = useState(false);

  //console.log(userPermission);

  // Format currency values
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getParsedDate = (value) => {
  if (!value) return null;

  let parsedDate = null;

  // Case 1: ISO format (yyyy-MM-dd)
  if (value.includes("-")) {
    parsedDate = parseISO(value);
  }

  // Case 2 & 3: Slash formats
  else if (value.includes("/")) {
    const parts = value.split("/");

    if (parts.length === 2) {
      // "1/2026" → M/yyyy
      parsedDate = parse(value, "M/yyyy", new Date());
    } 
    else if (parts.length === 3) {
      // "1/5/2026"
      // Assume dd/MM/yyyy (common in India)
      parsedDate = parse(value, "d/M/yyyy", new Date());
    }
  }

  return isValid(parsedDate) ? parsedDate : null;
};


  const getCurProjectDetails = async () => {
    setLoading(false);
    // setLoading(true);
    // Swal.fire({
    //   // title: 'Loading...',
    //   html: 'Please wait while we process your request...',
    //   allowOutsideClick: false,
    //   didOpen: () => {
    //     Swal.showLoading();
    //   },
    //   customClass: {
    //     popup: 'custom-swal'
    //   }
    // });
    //setLoading(false);
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };

    try {
      const response = await queuedApiFetch(`/project/get_user_projectdetails?userid=${userId}&proj_number=${projectNum}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        if (data.data != null) {
          setCurrentProject(data.data);
          localStorage.setItem('projectDetails', JSON.stringify({
            projectName: data.data.Proj_Name,
            projectNumber: data.data.Proj_Number,
            SC_Number: data.data.SC_Number,
            URN_List: data.data.URN_List,
            Proj_Access: data.proj_access
          }));
        }

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {

      Swal.close();
      setTimeout(() => {
        setLoading(false);
      }, 10000);
      //setLoading(false);
    }
  };

  const fetchUserCompany = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      const response = await queuedApiFetch(`/user/getuserprofile?emailid=${getUserEmail}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        setUserCompany(data.data.company_name);
        setUserPermission(data.data.access_level);
        //setUserCompany('BIMAGE');
        //setUserPermission('project_user');    
        //  setUserCompany('UAT Maincon A');
        //   setUserPermission('project_admin');    
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      //setLoading(false); // End loading
    }
  }

  const fetchUserRole = async () => {
    if (!userId || !projectNum) {
      return;
    }
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' })
    };
    try {
      // const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/project/get_project_role?userid=${userId}&projectid=${defaultProjectNumber}`, requestOptions);
      const response = await queuedApiFetch(`/project/get_project_role?userid=${userId}&projectid=${projectNum}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        // console.log(data.data); 
        //data.data[0]="Consultant";
        setUserRolesManual(data.data);
        setProjAccessLevel(data.access_level);
        //setUserRolesManual('Consultant');
        //setUserRolesManual('Contractor');
        //setUserRolesManual('NUS Information Technology (NUSIT)');
        //setUserRolesManual('Admin');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      //setLoading(false); // End loading
    }
  }

  const upsertURNForm = async () => {

    const requestOptions = {
      method: 'POST',
      // headers: new Headers({
      //   'Content-Type': 'application/json',
      //   'ngrok-skip-browser-warning': '69420',
      // }),
    };

    try {
      const response = await queuedApiFetch(`/project/upsert_urn_form?account_id=${accountId}&project_id=${projectNum}`, requestOptions);
      const data = await response;

      if (data.apistatus.Status_Code === 200 && data.apistatus.Status_Description.toLowerCase() === 'success') {
        const projectDetails = JSON.parse(localStorage.getItem('projectDetails'));
        const newURNList = data.data;

        if (projectDetails) {
          projectDetails.URN_List = newURNList;
        }
        // console.log('Updated URN List:', newURNList);

        // update in local storage
        localStorage.setItem('projectDetails', JSON.stringify(projectDetails));
        // console.log('Project details updated in local storage:', projectDetails); 

      }
    } catch (error) {
      console.error('Error during fetch request:', error);
    } finally {
    }
  };

  const getLOAData = async () => {
    const requestOptions = {
      method: 'GET',
      //headers: new Headers({ 'ngrok-skip-browser-warning': '69420' }),
    };

    try {
      const response = await queuedApiFetch(`/funding/get_loa_po_list?projectid=${projectNum}`,
        requestOptions
      );
      const result = await response;

      if (
        result?.apistatus?.Status_Code === 200 &&
        result?.apistatus?.Status_Description.toLowerCase() === 'success'
      ) {
        const allData = result.data;

        // Consultant filter
        const consultantAndQSItems = allData.filter(item => {
          const desc = item.description?.toLowerCase() || '';
          return (
            desc.includes("consultant (arch)") ||
            desc.includes("qs") ||
            desc.includes("consultant (c&s)") ||
            desc.includes("consultant (m&e)")
          );
        });

        // Contractor = everything else
        const contractItems = allData.filter(item => {
          const desc = item.description;
          if (!desc) return false; // skip items without description

          const lowerDesc = desc.toLowerCase();
          return !(
            lowerDesc.includes("consultant (arch)") ||
            lowerDesc.includes("qs") ||
            lowerDesc.includes("consultant (c&s)") ||
            lowerDesc.includes("consultant (m&e)") ||
            // lowerDesc.includes("fees") ||
            lowerDesc.includes("id furniture") ||
            lowerDesc.includes("gst adjustment")
          );
        });


        setConsultantVendors(consultantAndQSItems);
        setContractVendors(contractItems);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      // In case of an error, clear the state
      setContractVendors([]);
      setConsultantVendors([]);
    }
  };



  useEffect(() => {
    const fetchData = async () => {
      try {
        await getLOAData();
        await fetchUserCompany();
        await fetchUserRole();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    upsertURNForm();
    //  setTimeout(() => {getCurProjectDetails();}, 3000);
    getCurProjectDetails();
  }, []);

  // const handleEditField = (field, value) => {
  //   setCurrentProject((prevProject) => ({
  //     ...prevProject, // Keep existing fields
  //     [field]: value, // Update the specific field
  //   }));
  // };

  const handleEditField = (field, value) => {
    setCurrentProject((prevProject) => {

      const updatedProject = {
        ...prevProject, // Keep existing fields
        [field]: value, // Update the specific field
      };

      // When Baseline changes, automatically calculate dates
      if (field === 'Baseline') {

        // If Baseline is cleared, clear calculated dates
        if (!value) {
          updatedProject.Capsheet = null;
          updatedProject.AsBuilt = null;
          updatedProject.FinalAccount = null;
        }
        else {
          const baselineDate = parseISO(value);

          // Capsheet = Baseline + 3 months
          updatedProject.Capsheet = format(
            addMonths(baselineDate, 3),
            'yyyy-MM-dd'
          );

          // As Built = Baseline + 6 months
          updatedProject.AsBuilt = format(
            addMonths(baselineDate, 6),
            'yyyy-MM-dd'
          );

          // Final Account = Baseline + 12 months
          updatedProject.FinalAccount = format(
            addMonths(baselineDate, 12),
            'yyyy-MM-dd'
          );
        }
      }

      return updatedProject;
    });
  };

  const updateProjectMasterList = async () => {



    // Avoid submitting if already in progress  
    if (submitLoading) return;

    // --- VALIDATION START ---
    //const { Proj_StartDate,Proj_EndDate,Exptd_Cons_StartDate, Exptd_Cons_EndDate, Contractual_Cons_StartDate, Contractual_Cons_EndDate, Actual_Authority_submissions, Exptd_Authority_submissions } = currentProject;

    const {
      Proj_StartDate,
      Proj_EndDate,
      Exptd_Cons_StartDate,
      Exptd_Cons_EndDate,
      Contractual_Cons_StartDate,
      Contractual_Cons_EndDate,
      Actual_Authority_submissions,
      Exptd_Authority_submissions,

      Baseline,
      Capsheet,
      AsBuilt,
      FinalAccount,
      ActualCapsheetDate,
      ActualAsBuiltDate,
      ActualFinalAccountDate
    } = currentProject;

    // Utility: compare only if both dates are present
    // const isAfter = (start, end) => {
    //   if (!start || !end) return false; // skip validation if either is missing
    //   return new Date(start) > new Date(end);
    // };

    const parseDate = (date) => {
      if (!date) return null;

      const parsed = new Date(date);

      return isNaN(parsed.getTime()) ? null : parsed;
    };


    // Compare date only (ignores time)
    const isAfter = (start, end) => {
      if (!start || !end) return false;

      const startDate = parseDate(start);
      const endDate = parseDate(end);

      if (!startDate || !endDate) return false;

      return startDate > endDate;
    };

    // Check whether date2 is exactly N months after date1
    const isExactlyMonthsAfter = (baseDate, targetDate, months) => {

      if (!baseDate || !targetDate) return true;

      const base = parseDate(baseDate);
      const target = parseDate(targetDate);

      if (!base || !target) return false;

      const expectedDate = new Date(base);

      expectedDate.setMonth(expectedDate.getMonth() + months);

      return (
        expectedDate.getFullYear() === target.getFullYear() &&
        expectedDate.getMonth() === target.getMonth() &&
        expectedDate.getDate() === target.getDate()
      );
    };

    // --------------------------------------------------
    // Existing validations
    // --------------------------------------------------

    if (isAfter(Proj_StartDate, Proj_EndDate)) {
      showToast.error("Project Start Date cannot be later than Project End Date.");
      return;
    }

    if (isAfter(Exptd_Cons_StartDate, Exptd_Cons_EndDate)) {
      showToast.error("Expected Construction Start Date cannot be later than Expected Construction End Date.");
      return;
    }

    if (isAfter(Contractual_Cons_StartDate, Contractual_Cons_EndDate)) {
      showToast.error("Contractual Construction Start Date cannot be later than Contractual Construction End Date.");
      return;
    }

    if (isAfter(Actual_Authority_submissions, Exptd_Authority_submissions)) {
      showToast.error("Detailed Design and Authority Submission Start Date cannot be later than Detailed Design and Authority Submission End Date.");
      return;
    }

    // --------------------------------------------------
    // Baseline / Capsheet / As Built / Final Account
    // --------------------------------------------------

     // 1. Baseline is mandatory
  if (!Baseline) {

    showToast.error(
      "Baseline Date is mandatory."
    );

    return;
  }


  // 2. Capsheet is mandatory
  if (!Capsheet) {

    showToast.error(
      "Capsheet Date is mandatory."
    );

    return;
  }


  // 3. As Built is mandatory
  if (!AsBuilt) {

    showToast.error(
      "As Built Date is mandatory."
    );

    return;
  }


  // 4. Final Account is mandatory
  if (!FinalAccount) {

    showToast.error(
      "Final Account Date is mandatory."
    );

    return;
  }

    // Capsheet = Baseline + 3 months
    if (Baseline && Capsheet) {

      if (!isExactlyMonthsAfter(Baseline, Capsheet, 3)) {
        showToast.error(
          "Capsheet Date must be exactly 3 months after the Baseline Date."
        );
        return;
      }
    }


    // As Built = Baseline + 6 months
    if (Baseline && AsBuilt) {

      if (!isExactlyMonthsAfter(Baseline, AsBuilt, 6)) {
        showToast.error(
          "As Built Date must be exactly 6 months after the Baseline Date."
        );
        return;
      }
    }


    // Final Account = Baseline + 12 months
    if (Baseline && FinalAccount) {

      if (!isExactlyMonthsAfter(Baseline, FinalAccount, 12)) {
        showToast.error(
          "Final Account Date must be exactly 12 months after the Baseline Date."
        );
        return;
      }
    }


    // --------------------------------------------------
    // Actual Dates Validation
    // --------------------------------------------------

    // // Actual Capsheet cannot be before Baseline
    // if (Baseline && ActualCapsheetDate) {

    //   if (isAfter(Baseline, ActualCapsheetDate)) {
    //     showToast.error(
    //       "Actual Capsheet Date cannot be earlier than the Baseline Date."
    //     );
    //     return;
    //   }
    // }


    // // Actual As Built cannot be before Actual Capsheet
    // if (ActualCapsheetDate && ActualAsBuiltDate) {

    //   if (isAfter(ActualCapsheetDate, ActualAsBuiltDate)) {
    //     showToast.error(
    //       "Actual As Built Date cannot be earlier than the Actual Capsheet Date."
    //     );
    //     return;
    //   }
    // }


    // // Actual Final Account cannot be before Actual As Built
    // if (ActualAsBuiltDate && ActualFinalAccountDate) {

    //   if (isAfter(ActualAsBuiltDate, ActualFinalAccountDate)) {
    //     showToast.error(
    //       "Actual Final Account Date cannot be earlier than the Actual As Built Date."
    //     );
    //     return;
    //   }
    // }

    // --- VALIDATION END ---

    setLoading(true);
    setSubmitLoading(true);
    const sendData = currentProject;
    const requestOptions = {
      method: 'POST',
      // headers: {
      //   'Content-Type': 'application/json',
      //   'ngrok-skip-browser-warning': '69420',
      // },
      body: JSON.stringify(sendData),
    };

    try {
      const response = await queuedApiFetch(`/project/updateprojectmasterdetails`,
        requestOptions
      );
      const result = await response;

      // Check if the response status is successful
      if (result.apistatus.Status_Code === 200 && result.apistatus.Status_Description.toLowerCase() === 'success') {
        showToast.success('Project Details Updated Successfully');
        // localStorage.setItem('lastActiveRoute', '/checklistacc');
        // navigate('/checklistacc');
      } else {
        showToast.error(result.apistatus.Status_Description || 'Error occurred. Please try again.');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      showToast.error('Something went wrong. Please try again.');
    } finally {
      setSubmitLoading(false); // Ensure loading state is reset after completion
      setLoading(false);
    }
  };

  // const nus_admin_sts=(expectedCompany)=>{
  //       return (getUserCompanyDetails===expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin'));
  //     };

  // const nus_admin_sts=(expectedCompany,projectAdminRoles = [])=>{
  //       return ((getUserCompanyDetails===expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin') && userRoleManual?.length===0) ||
  //     projectAdminRoles.some(item=>userRoleManual?.includes?.(item)) );
  //     };

  const nus_admin_sts = (expectedCompany, projectAdminRoles = []) => {
    return (
      (getUserCompanyDetails === expectedCompany && proj_access_level === true) ||
      projectAdminRoles.some(item => userRoleManual?.includes?.(item)));
  };

  // const nus_admin_sts=(expectedCompany,projectAdminRoles = [])=>{
  //   return ((getUserCompanyDetails===expectedCompany && (userPermission === 'account_admin' || userPermission === 'project_admin')) || (userRoleManual?.length===0||
  // projectAdminRoles.some(item=>userRoleManual?.includes?.(item)) ) );
  // };

  return (
    <>
      {(nus_admin_sts('NUS', ['Project Manager (PM)'])) ? (
        <div className="project-card">
          {loading && <FullscreenLoader />}
          <div className="card-header">
            <h2 className="card-title">Project details</h2>
          </div>
          {loading ?
            (<>
              <div className="loading-container">
                {/* <div className="loading-spinner"></div> */}
                <p>Loading project details...</p>
              </div>
            </>)
            :
            currentProject.length == 0 ?
              <>
                <div className="loading-container">
                  <p>No Records Found!</p>
                </div>
              </>
              :
              <>
                <div className="card-content">
                  <div className="grid-container">
                    {/* Left Column */}
                    <div className="details-column">
                      {/* <div className="detail-row">
                        <span className="detail-label-default">Sno.</span>
                        <span className="detail-value-default">{currentProject.Sno}</span>
                      </div> */}
                      <div className="detail-row">
                        <span className="detail-label-default">Project Name</span>
                        <span className="detail-value-default">{currentProject.Proj_Name}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Project Number</span>
                        <span className="detail-value-default">{currentProject.SC_Number}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Tender_Ref_No</span>
                        <input
                          type="text"
                          value={currentProject.tender_ref_no}
                          onChange={(e) =>
                            handleEditField('tender_ref_no', e.target.value)
                          }
                        />
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Project Manager Name</span>
                        <span className="detail-value-default">{currentProject.PM_Name}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Project Director Name</span>
                        <span className="detail-value-default">{currentProject.PD_Name}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Project Department</span>
                        {/* <span className="detail-value">{currentProject.Proj_Dept}</span> */}
                        <input
                          type="text"
                          value={currentProject.Proj_Dept}
                          onChange={(e) =>
                            handleEditField('Proj_Dept', e.target.value)
                          }
                        />
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Project Address</span>
                        <span className="detail-value-default">{currentProject.Proj_Address}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">CPRS Number</span>
                        <span className="detail-value-default">{currentProject.CPRS_Number}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Total Development Cost</span>
                        <span className="detail-value-default">{userPermission !== 'account_admin' || userPermission !== 'project_admin' && getUserCompanyDetails === 'NUS' ? formatCurrency(currentProject.Proj_Approved_Budget) : null}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Total Project Cost (w GST)</span>
                        <span className="detail-value-default">{userPermission !== 'account_admin' || userPermission !== 'project_admin' && getUserCompanyDetails === 'NUS' ? formatCurrency(currentProject.Proj_Cost) : null}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Construction Cost</span>
                        <span className="detail-value-default">{userPermission !== 'account_admin' || userPermission !== 'project_admin' && getUserCompanyDetails === 'NUS' ? formatCurrency(currentProject.Construction_Cost) : null}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">GFA (Gross Floor Area)</span>
                        <span className="detail-value-default">{currentProject.GFA}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Project Stage</span>
                        <span className="detail-value-default">{currentProject.Proj_Stage}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Project Progress Status</span>
                        <span className="detail-value-default">{currentProject.Proj_Progress_Status}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Potential Extension of Time (Days)</span>
                        <span className="detail-value">
                          <input
                            style={{ border: '1px solid #ccc' }}
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="number"
                            value={currentProject.Potential_Extn_of_Time || 0}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              const parsedValue = isNaN(newValue) ? 0 : parseInt(newValue, 10);
                              handleEditField('Potential_Extn_of_Time', parsedValue);
                            }}
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Granted Extension of Time (Days)</span>
                        <span className="detail-value">
                          <input
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            style={{ border: '1px solid #ccc' }}
                            type="number"
                            value={currentProject.Granted_Extn_of_Time || 0}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              const parsedValue = isNaN(newValue) ? 0 : parseInt(newValue, 10);
                              handleEditField('Granted_Extn_of_Time', parsedValue);
                            }}
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Consultant Names</span>
                        {/* <span className="detail-value">{currentProject.Consultant_Names}</span> */}
                        <span className="detail-value-default">
                          {ConsultantVendors.filter(vendor => vendor.vendor_name).map((vendor, index, array) => (
                            <React.Fragment key={index}>
                              {vendor.vendor_name}{index < array.length - 1 ? ',' : ''}
                              <br />
                            </React.Fragment>
                          ))}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label-default">Contractor Names</span>
                        <span className="detail-value-default">
                          {ContractVendors.filter(vendor => vendor.vendor_name).map((vendor, index, array) => (
                            <React.Fragment key={index}>
                              {vendor.vendor_name}{index < array.length - 1 ? ',' : ''}
                              <br />
                            </React.Fragment>
                          ))}
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Building Code</span>
                        <span className="detail-value">
                          <input
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={currentProject.Building_Code}
                            onChange={(e) =>
                              handleEditField('Building_Code', e.target.value)
                            }
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Submission Remarks</span>
                        <span className="detail-value">
                          <textarea
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={currentProject.Submission_Remarks}
                            onChange={(e) =>
                              handleEditField('Submission_Remarks', e.target.value)
                            }
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Project Status Remarks</span>
                        <span className="detail-value">
                          <textarea
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            type="text"
                            value={currentProject.Project_Status_Remarks}
                            onChange={(e) =>
                              handleEditField('Project_Status_Remarks', e.target.value)
                            }
                          />
                        </span>
                      </div>
                      
                      <div className="detail-row">
                        <span className="detail-label-default">CPRS Approval Date</span>
                        <span className="detail-value-default">{formatDate(currentProject.CPRS_Approval_Date)}</span>
                      </div>
                      <div className="detail-row">
                        {/* <span className="detail-label-default">Project Start Date</span>
                        <span className="detail-value-default">{currentProject.Proj_StartDate}</span> */}

                        <span className="detail-label">Project Start Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            // selected={currentProject.Proj_StartDate ? parseISO(currentProject.Proj_StartDate, 'yyyy-MM-dd', new Date()) : null}
                            selected={getParsedDate(currentProject.Proj_StartDate)}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              // ensure state always stores string
                              setCurrentProject((prev) => ({
                                ...prev,
                                Proj_StartDate: formattedDate,
                              }));
                              handleEditField('Proj_StartDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>

                      </div>
                      <div className="detail-row">
                        {/* <span className="detail-label-default">Project End Date</span>
                        <span className="detail-value-default">{currentProject.Proj_EndDate}</span> */}
                        <span className="detail-label">Project End Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            // selected={currentProject.Proj_EndDate ? parseISO(currentProject.Proj_EndDate, 'yyyy-MM-dd', new Date()) : null}
                            selected={getParsedDate(currentProject.Proj_EndDate)}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              // ensure state always stores string
                              setCurrentProject((prev) => ({
                                ...prev,
                                Proj_EndDate: formattedDate,
                              }));
                              handleEditField('Proj_EndDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>

                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Expected Construction Start Date</span>
                        <span className="detail-value">
                          <DatePicker
                            //{currentProject.Exptd_Cons_StartDate}
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Exptd_Cons_StartDate ? parseISO(currentProject.Exptd_Cons_StartDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Exptd_Cons_StartDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      

                    </div>

                    {/* Right Column */}
                    <div className="details-column">

                      <div className="detail-row">
                        <span className="detail-label">Expected Construction End Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Exptd_Cons_EndDate ? parseISO(currentProject.Exptd_Cons_EndDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Exptd_Cons_EndDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>

                      <div className="detail-row">
                        <span className="detail-label">Expected Main Contractor Calling Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Exptd_Main_Contractor_Calling_Date ? parseISO(currentProject.Exptd_Main_Contractor_Calling_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Exptd_Main_Contractor_Calling_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Expected Main Contract Award Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Exptd_Main_Contract_Award_Date ? parseISO(currentProject.Exptd_Main_Contract_Award_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Exptd_Main_Contract_Award_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Contractual Construction Start Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Contractual_Cons_StartDate ? parseISO(currentProject.Contractual_Cons_StartDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Contractual_Cons_StartDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Contractual Construction End Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Contractual_Cons_EndDate ? parseISO(currentProject.Contractual_Cons_EndDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Contractual_Cons_EndDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Actual Construction End Date</span>
                        <span className="detail-value">{formatDate(currentProject.Actual_Cons_EndDate)}</span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">CSC Date (Certificate of Statutory Completion)</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.CSC_Date ? parseISO(currentProject.CSC_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('CSC_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Handover Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Handover_Date ? parseISO(currentProject.Handover_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Handover_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">TOP Date (Temporary Occupation Permit)</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.TOP_Date ? parseISO(currentProject.TOP_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('TOP_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">DLP Expiry Date (Defects Liability Period)</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.DLP_Expiry_Date ? parseISO(currentProject.DLP_Expiry_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('DLP_Expiry_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Expected Appointment of Consultants</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Exptd_appnmt_of_Consultants ? parseISO(currentProject.Exptd_appnmt_of_Consultants, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Exptd_appnmt_of_Consultants', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Expected Handover Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Exptd_Handover_Date ? parseISO(currentProject.Exptd_Handover_Date, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Exptd_Handover_Date', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Detailed Design and Authority Submission Start Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Actual_Authority_submissions ? parseISO(currentProject.Actual_Authority_submissions, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Actual_Authority_submissions', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Detailed Design and Authority Submission End Date</span>
                        <span className="detail-value">
                          <DatePicker
                            // disabled={getUserAccess == 'project_admin' ? false : true}
                            selected={currentProject.Exptd_Authority_submissions ? parseISO(currentProject.Exptd_Authority_submissions, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Exptd_Authority_submissions', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                       {/* New Date fields added on 11-09-2026 */}   
                      <div className="detail-row">
                        <span className="detail-label">Baseline</span>
                        <span className="detail-value">
                          <DatePicker                           
                            selected={currentProject.Baseline ? parseISO(currentProject.Baseline, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('Baseline', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Capsheet</span>
                        <span className="detail-value">
                          <DatePicker   
                            className="calculated-date"                        
                            selected={currentProject.Capsheet ? parseISO(currentProject.Capsheet, 'yyyy-MM-dd', new Date()) : null}                           
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                            disabled
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">As Built</span>
                        <span className="detail-value">
                          <DatePicker  
                            className="calculated-date"                         
                            selected={currentProject.AsBuilt ? parseISO(currentProject.AsBuilt, 'yyyy-MM-dd', new Date()) : null}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                            disabled
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Final Account</span>
                        <span className="detail-value">
                          <DatePicker   
                            className="calculated-date"                        
                            selected={currentProject.FinalAccount ? parseISO(currentProject.FinalAccount, 'yyyy-MM-dd', new Date()) : null}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                            disabled
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Actual Capsheet Date</span>
                        <span className="detail-value">
                          <DatePicker                           
                            selected={currentProject.ActualCapsheetDate ? parseISO(currentProject.ActualCapsheetDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('ActualCapsheetDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Actual As Built Date</span>
                        <span className="detail-value">
                          <DatePicker                           
                            selected={currentProject.ActualAsBuiltDate ? parseISO(currentProject.ActualAsBuiltDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('ActualAsBuiltDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>
                      <div className="detail-row">
                        <span className="detail-label">Actual Final Account Date</span>
                        <span className="detail-value">
                          <DatePicker                           
                            selected={currentProject.ActualFinalAccountDate ? parseISO(currentProject.ActualFinalAccountDate, 'yyyy-MM-dd', new Date()) : null}
                            onChange={(date) => {
                              const formattedDate = (date == null) ? date : format(date, 'yyyy-MM-dd');
                              handleEditField('ActualFinalAccountDate', formattedDate);
                            }}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="dd-MM-yyyy"
                          />
                        </span>
                      </div>

                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  {/* <button 
                          className={`${getUserAccess !== 'project_admin' || getUserCompanyDetails !== 'NUS' ? 'button-grey' : 'submit-button'}`} 
                          disabled={submitLoading || currentProject.length == 0 ? true : false || getUserCompanyDetails !== 'NUS' } 
                          onClick={updateProjectMasterList}>Submit</button> */}
                  {/* <button 
                          className={`${(userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS' ? 'button-grey' : 'submit-button'}`} 
                          disabled={submitLoading || currentProject.length == 0 ? true : false || (userPermission !== 'account_admin' || userPermission !== 'project_admin') && getUserCompanyDetails !== 'NUS' } 
                          onClick={updateProjectMasterList}>Update</button> */}

                  <button
                    className={`${(proj_access_level === false) && getUserCompanyDetails !== 'NUS' ? 'button-grey' : 'submit-button'}`}
                    disabled={submitLoading || currentProject.length == 0 ? true : false || (proj_access_level === false) && getUserCompanyDetails !== 'NUS'}
                    onClick={updateProjectMasterList}>Update</button>
                </div>
              </>
          }
        </div>
      ) : null}

    </>
  );
}

export default UpdateProjectDetails;
